
import React from 'react';
import { motion } from 'framer-motion';
import { 
  Code2, 
  Cpu, 
  Terminal, 
  ShieldCheck, 
  Layers, 
  Palette,
  Bot
} from 'lucide-react';

const services = [
  {
    icon: <Code2 size={24} />,
    title: 'Software Development',
    items: [
      'Full-stack web platforms',
      'Backend systems & APIs',
      'Software architecture',
      'Secure & scalable systems'
    ]
  },
  {
    icon: <Cpu size={24} />,
    title: 'AI & Intelligence',
    items: [
      'LLM integration & fine-tuning',
      'Automation pipelines',
      'Intelligent agents',
      'Data-driven insights'
    ]
  },
  {
    icon: <Bot size={24} />,
    title: 'Automation & Bots',
    items: [
      'Custom Discord & Telegram bots',
      'Workflow automation',
      'Real-time processing',
      'Secure bot environments'
    ]
  },
  {
    icon: <Terminal size={24} />,
    title: 'Linux & Systems',
    items: [
      'Server infrastructure',
      'Performance optimization',
      'Security hardening',
      'Container orchestration'
    ]
  },
  {
    icon: <Palette size={24} />,
    title: 'Logic-Driven Design',
    items: [
      'UI/UX design systems',
      'Product-focused flows',
      'Visual identities',
      'Developer-centric UX'
    ]
  },
  {
    icon: <Layers size={24} />,
    title: 'Infrastructure',
    items: [
      'Cloud deployments',
      'CI/CD pipelines',
      'DB management',
      'System monitoring'
    ]
  }
];

const Services: React.FC = () => {
  return (
    <section id="services" className="py-32 bg-[#000000]">
      <div className="max-w-7xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-zinc-600 text-[11px] uppercase tracking-[0.5em] font-bold mb-6">Capabilities</h2>
          <h3 className="text-4xl md:text-5xl font-bold tracking-tight">Technical Solutions.</h3>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, i) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              whileHover={{ y: -5 }}
              className="p-10 rounded-[2.5rem] bg-[#0A0A0A] border border-white/5 hover:border-violet-500/20 transition-all group relative overflow-hidden"
            >
              <div className="absolute top-0 right-0 p-8 opacity-5 group-hover:opacity-10 transition-opacity">
                {service.icon}
              </div>
              
              <div className="w-12 h-12 rounded-2xl bg-white/5 border border-white/10 flex items-center justify-center mb-8 text-zinc-400 group-hover:text-violet-400 group-hover:border-violet-500/30 transition-colors">
                {service.icon}
              </div>
              
              <h4 className="text-xl font-bold mb-6 tracking-tight text-white">{service.title}</h4>
              
              <ul className="space-y-3">
                {service.items.map((item) => (
                  <li key={item} className="text-sm text-zinc-500 flex items-center gap-2 font-medium">
                    <span className="w-1 h-1 rounded-full bg-violet-900/50" />
                    {item}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
